import React from 'react'

import { DefaultMediaWizardLayout } from './DefaultMediaWizardLayout'

import { UserManagement as UserManagementComponent } from 'components/UserManagement/UserManagement'
import { Breadcrumb } from 'components/Links'

import { useDocumentTitle } from '@percept/hooks'


const breadcrumbs: Breadcrumb[] = [
  {
    path: '/wizard/user-management',
    name: 'User Management',
  },
]


export const UserManagement = (): JSX.Element => {
  useDocumentTitle({ paths: ['User Management'] })
  return (
    <DefaultMediaWizardLayout
      breadcrumbs={breadcrumbs}>

      <UserManagementComponent />

    </DefaultMediaWizardLayout>
  )
}
